module.exports = __webpack_public_path__ + "img/styling.95a60d6.svg";